<!-- FAB Chatbot Component -->
<div class="chatbot-fab-container">
  <!-- FAB Button - Hide when chatbot is open -->
  <button type="button" class="chatbot-fab" (click)="toggleChat()" [class.active]="open" [title]="open ? 'Close DigiBot' : 'Open DigiBot'" *ngIf="!open">
    <i class="fas fa-comments"></i>
  </button>

  <!-- Chatbot Popup -->
  <div class="chatbot-popup-fab" *ngIf="open">
    <!-- Guidebook Modal -->
    <div *ngIf="showGuidebook" class="guidebook-overlay">
      <div class="guidebook-content">
        <div class="guidebook-header">
          <h4>DigiBot Usage Guide</h4>
          <button (click)="toggleGuidebook()" class="guidebook-close">&times;</button>
        </div>
        <div class="guidebook-body">
          <p>Welcome to DigiBot! You can ask about:</p>
          <ul>
            <li *ngFor="let command of guideCommands">{{ command }}</li>
          </ul>
          <p class="guidebook-tip">
            <strong>Tip:</strong> Type your questions naturally, DigiBot understands conversational language!
          </p>
        </div>
      </div>
    </div>

    <!-- Chat Header -->
    <div class="chatbot-header">
      <h5>DigiBot</h5>
      <div class="chatbot-header-right">
        <div class="chatbot-controls">
          <button class="control-btn guide-btn" (click)="toggleGuidebook()" title="Usage Guide">
            <i class="fas fa-book"></i>
          </button>
          <button class="control-btn" (click)="increaseFontSize()" title="Increase Font Size">
            <i class="fas fa-search-plus"></i>
          </button>
          <button class="control-btn" (click)="decreaseFontSize()" title="Decrease Font Size">
            <i class="fas fa-search-minus"></i>
          </button>
          <button class="control-btn clear-btn" (click)="clearChat()" title="Clear Chat">
            <i class="fas fa-trash-alt"></i>
          </button>
        </div>
        <button class="chatbot-close-btn" (click)="toggleChat()" title="Close DigiBot">
          <i class="fas fa-times"></i>
        </button>
      </div>
    </div>

    <!-- Chat Messages -->
    <app-chatbot-messages
      [messages]="messages"
      [isLoading]="isLoading"
      [fontSize]="fontSize"
      (recommendedAnswerSelected)="onRecommendedAnswerSelected($event)"
      (followUpQuestionSelected)="onFollowUpQuestionSelected($event)"
      (extractInputSelected)="onExtractInputSelected($event.request, $event.displayLabel)">
    </app-chatbot-messages>

    <!-- Chat Input -->
    <div class="chatbot-input">
      <input [(ngModel)]="newMessage" (keydown.enter)="send()" placeholder="Ask something..." [disabled]="isLoading"
        [style.font-size.px]="fontSize" />
      <button (click)="send()" [disabled]="isLoading || !newMessage.trim()">
        {{ isLoading ? 'Sending...' : 'Send' }}
      </button>
    </div>
  </div>
</div>
